export const UNCATEGORIZED_ID = "__uncategorized__";

export interface CategoryGroup<T> {
  id: string;
  name: string;
  items: T[];
}

/**
 * Groups menu items by their category for the quote add-item picker (#817).
 * Groups are sorted by name; items without a category go in a trailing
 * "Uncategorized" group so the category filter can still reach them. Item
 * order within a group is kept as given.
 */
export function groupItemsByCategory<T extends { category?: { id?: string; name: string } | null }>(
  items: T[],
): CategoryGroup<T>[] {
  const byId = new Map<string, CategoryGroup<T>>();
  const uncategorized: T[] = [];
  for (const item of items) {
    const category = item.category;
    if (!category?.id) {
      uncategorized.push(item);
      continue;
    }
    const group = byId.get(category.id);
    if (group) group.items.push(item);
    else byId.set(category.id, { id: category.id, name: category.name, items: [item] });
  }
  const groups = [...byId.values()].sort((a, b) => a.name.localeCompare(b.name));
  if (uncategorized.length > 0) groups.push({ id: UNCATEGORIZED_ID, name: "Uncategorized", items: uncategorized });
  return groups;
}
